import styled from '@emotion/styled';
import { ImageOutlined as ImageIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line react-refresh/only-export-components
export const ImageProcessingStateWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '.MuiSvgIcon-root': {
    marginBottom: 24,
    width: 48,
    height: 48,
    color: theme.palette.text.secondary,
  },
  '> div': {
    display: 'flex',
    alignItems: 'center',
    '.MuiCircularProgress-root': {
      marginRight: 12,
      color: theme.palette.text.secondary,
    },
    p: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
}));

const ThumbnailProcessingState = () => (
  <ImageProcessingStateWrapper>
    <ImageIcon />
    <div>
      <CircularProgress size={18} />
      <p>
        <FormattedMessage id="portfolio.challenge.thumbnail_header.processing_state.message" />
      </p>
    </div>
  </ImageProcessingStateWrapper>
);

export default ThumbnailProcessingState;
